import React, { useState } from "react";
import Hero from "./Hero";
import Features from "./Features";
import Pricing from "./Pricing";
import Testimonials from "./Testimonials";
import FAQ from "./FAQ";
import CTASection from "./CTASection";
import Footer from "./Footer";
import Navbar from "./Navbar";
import DemoExamSection from "./DemoExamSection";
import LoginModal from "../Auth/LoginModal";
import RegisterModal from "../Auth/RegisterModal";
import DemoModal from "./DemoModal";
import ForgotPasswordModal from "../Auth/ForgotPasswordModal";

const LandingPage = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [isDemoOpen, setIsDemoOpen] = useState(false);
  const [showForgot, setShowForgot] = useState(false);

  // Función específica para la transición Demo -> Registro
  const handleRegisterFromDemo = () => {
    setIsDemoOpen(false); // Cierra la demo
    setShowRegister(true); // Abre el registro
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar
        onLoginClick={() => setShowLogin(true)}
        onRegisterClick={() => {
          setShowLogin(false);
          setShowRegister(true);
        }}
      />

      {/* Hero Section */}
      <Hero
        onCtaClick={() => setShowRegister(true)}
        onDemoClick={() => setIsDemoOpen(true)}
      />

      <Features />

      {/* Nueva Sección Demo */}
      <DemoExamSection onDemoClick={() => setIsDemoOpen(true)} />

      <Pricing onRegisterClick={() => setShowRegister(true)} />

      <Testimonials />

      <FAQ />

      {/* CTA Final */}
      <CTASection onCtaClick={() => setShowRegister(true)} />

      <Footer />

      {/* --- MODALES --- */}

      {/* Login Modal */}
      <LoginModal
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        onSwitchToRegister={() => {
          setShowLogin(false);
          setShowRegister(true);
        }}
        onForgotPassword={() => {
          setShowLogin(false);
          setShowForgot(true);
        }}
      />
      {/* Register Modal */}
      <RegisterModal
        isOpen={showRegister}
        onClose={() => setShowRegister(false)}
        onSwitchToLogin={() => {
          setShowRegister(false);
          setShowLogin(true);
        }}
      />

      {/* Demo Modal: Ahora con onRegister conectado */}
      <DemoModal
        isOpen={isDemoOpen}
        onClose={() => setIsDemoOpen(false)}
        onRegister={handleRegisterFromDemo}
      />

      <ForgotPasswordModal
        isOpen={showForgot}
        onClose={() => setShowForgot(false)}
      />
    </div>
  );
};

export default LandingPage;
